import { render, staticRenderFns } from "./WithdrawRecordModal.vue?vue&type=template&id=8b187222&"
import script from "./WithdrawRecordModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports